module.exports = __webpack_public_path__ + "static/media/plugOff_118.6f39decd.png";